<template>
  <!-- 顺其自然的页面 / 不强制横屏的页面 -->
  <div v-if="!$route.meta.fixed && !$route.query.fixed">
    <p class="popup__p"><span>不满意</span><span>满意</span></p>
    <div class="popup-kd">
      <p>-10</p>
      <p><span>0</span><span>10</span></p>
    </div>
    <van-slider v-model="value" bar-height="15px" active-color="transparent" :max="props.max" :min="props.min" :disabled="disabled"
      @change="handleChange">
      <template #button>
        <div class="custom-button">
          <img src="@/assets/img/icon40.png" />
          <p>{{ value }}</p>
        </div>
      </template>
    </van-slider>
  </div>

  <!-- 强制横屏的页面 -->
  <div v-else class="landscapeFixed">
    <!-- 竖屏 -->
    <div class="portrait">
      <div style="relative auto BGon; width:300px" class="auto">
        <p class="flex between C999 size14"><span>不满意</span><span>满意</span></p>
        <div class="flex between C999">
          <p>-10</p>
          <span>0</span>
          <span>10</span>
        </div>
        <div class="pad20"></div>
        <div class="absolute l r t b auto" style="height:300px">
          <van-slider class="auto" style="transform:rotate(-90deg); " v-model="value" vertical bar-height="15px" active-color="transparent"
            :max="props.max" :min="props.min" @change="handleChange">
            <template #button>
              <div class="custom-button">
                <img src="@/assets/img/icon40.png" />
                <p>{{ value }}</p>
              </div>
            </template>
          </van-slider>
        </div>
      </div>
    </div>
    <!-- 直接横屏 -->
    <div class="landscape">
      <p class="popup__p"><span>不满意</span><span>满意</span></p>
      <div class="pad20"></div>
      <div class="popup-kd">
        <p>-10</p>
        <p><span>0</span><span>10</span></p>
      </div>
      <van-slider v-model="value" bar-height="15px" active-color="transparent" :max="props.max" :min="props.min" @change="handleChange">
        <template #button>
          <div class="custom-button">
            <img src="@/assets/img/icon40.png" />
            <p>{{ value }}</p>
          </div>
        </template>
      </van-slider>
    </div>

  </div>
</template>
<script setup>
import { defineEmits, defineProps, ref, toRefs } from 'vue';
import { useRoute } from "vue-router";

const value = ref(0)
const { query } = useRoute();
let { score } = query
if (score) {
  value.value = score
}

const props = defineProps({
  max: {
    type: Number,
    default: 10
  },
  min: {
    type: Number,
    default: -10
  },
  rateval: {
    type: Number,
    default: 0
  },
  disabled: {
    type: Boolean, default: false
  }
})
if (!score && props.rateval) {
  const val = toRefs(props)
  value.value = val.rateval.value
}
const emits = defineEmits(['updateVal'])
const handleChange = (val) => {
  emits("updateVal", val)
}
</script>

<style scoped lang="scss">

@media screen and (orientation: portrait) { /* 竖屏 */
  .landscapeFixed{
    .portrait .van-slider{
      background: linear-gradient(to bottom,gray,white,#3f7c93);
    }
    .custom-button{ transform: rotate(90deg) translateY(-22px) translateX(29px); }
  }
}
@media screen and (orientation: landscape) {
  /* 横屏 */
}


.custom-button {
    position: relative;
    width: 28px;
    height: 20px;
    bottom: 30px;
}
.custom-button p {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%,-50%);
    color: #ffffff;
    font-size: 10px;
}
.popup__p {
    width: calc(100% - 60px);
    display: flex;
    justify-content: space-between;
    color: #999999;
    font-size: 14px;
    position: absolute;
    top: 68px;
    box-sizing: border-box;
}
.popup-kd {
    width: calc(100% - 32px);
    position: absolute;
    left: 13px;
    top: 110px;
    display: flex;
    align-items: center;
}
.popup-kd p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 50%;
    font-size: 14px;
    color: #999999;
}
</style>